export const ambitionDeptKey = {
  createDepartment: "create new ambition department",
  updateDepartment: "update ambition department",
  deleteDepartment: "delete ambition department",
  createEfforts: "create department effort",
  updateEfforts: "update department effort",
  deleteEfforts: "delete department effort",
};
